<template>
  <div
    :class="{ 'has-danger': error }"
    class="form-group row">
    <label class="col-4 col-form-label">Город <span class="text-danger">*</span></label>
    <div class="col-8">
      <multiselect
        :options="cities"
        :searchable="true"
        :close-on-select="true"
        :show-labels="false"
        :value="city"
        placeholder="Город не выбран"
        track-by="id"
        label="name"
        autocomplete="off"
        @input="changeCity">
        <span slot="noResult">Город не найден.</span>
      </multiselect>
      <span
        v-if="error"
        class="small help-block text-danger">Город обязательно должен быть указан</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TcSelectCity',
  components: {Multiselect},
  computed: {
    ...mapState({
      cities: state => state.globalStore.cities
    })
  },
  props: {
    city: {
      type: Object,
      default: null
    },
    value: {
      default: null
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeCity ($city) {
      this.$emit('input', $city ? $city.id : null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TcSelectCity.vue?1fd41188